// removed by extract-text-webpack-plugin
module.exports = {"list":"antd-pro-notice-icon-list","item":"antd-pro-notice-icon-item","meta":"antd-pro-notice-icon-meta","avatar":"antd-pro-notice-icon-avatar","read":"antd-pro-notice-icon-read","title":"antd-pro-notice-icon-title","description":"antd-pro-notice-icon-description","datetime":"antd-pro-notice-icon-datetime","extra":"antd-pro-notice-icon-extra","notFound":"antd-pro-notice-icon-notFound","clear":"antd-pro-notice-icon-clear"};


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/src/components/NoticeIcon/NoticeList.less
// module id = 604
// module chunks = 0